import audio1 from 'assets/sounds/nn/diktat/sild.mp3';
import audio2 from 'assets/sounds/nn/diktat/skjelven.mp3';
import audio3 from 'assets/sounds/nn/diktat/godt.mp3';
import audio4 from 'assets/sounds/nn/diktat/kyllinger.mp3';
import audio5 from 'assets/sounds/nn/diktat/kjøt.mp3';
import audio6 from 'assets/sounds/nn/diktat/smarttelefon.mp3';
import audio7 from 'assets/sounds/nn/diktat/fugl.mp3';
import audio8 from 'assets/sounds/nn/diktat/sykkelhjelm.mp3';
import audio9 from 'assets/sounds/nn/diktat/hjarte.mp3';
import audio10 from 'assets/sounds/nn/diktat/kjeveortoped.mp3';
import audio11 from 'assets/sounds/nn/diktat/blåbærsyltetøy.mp3';
import audio12 from 'assets/sounds/nn/diktat/biblioteket.mp3';
import audio13 from 'assets/sounds/nn/diktat/kjetting.mp3';
import audio14 from 'assets/sounds/nn/diktat/sannsyn.mp3';
import audio15 from 'assets/sounds/nn/diktat/abrakadabra.mp3';
import audio16 from 'assets/sounds/nn/diktat/lov.mp3';
import audio17 from 'assets/sounds/nn/diktat/enn.mp3';
import audio18 from 'assets/sounds/nn/diktat/orsak.mp3';
import audio19 from 'assets/sounds/nn/diktat/kroppstemperatur.mp3';
import audio20 from 'assets/sounds/nn/diktat/reportasje.mp3';
import audio21 from 'assets/sounds/nn/diktat/skuldar.mp3';
import audio22 from 'assets/sounds/nn/diktat/også.mp3';
import audio23 from 'assets/sounds/nn/diktat/sjølvfølgje-new.mp3';
import audio24 from 'assets/sounds/nn/diktat/uveret.mp3';
import audio25 from 'assets/sounds/nn/diktat/kjedeleg.mp3';

const audioFiles = {
	1: audio1,
	2: audio2,
	3: audio3,
	4: audio4,
	5: audio5,
	6: audio6,
	7: audio7,
	8: audio8,
	9: audio9,
	10: audio10,
	11: audio11,
	12: audio12,
	13: audio13,
	14: audio14,
	15: audio15,
	16: audio16,
	17: audio17,
	18: audio18,
	19: audio19,
	20: audio20,
	21: audio21,
	22: audio22,
	23: audio23,
	24: audio24,
	25: audio25,
};

export default audioFiles;
